<template>
  <v-row>
    <v-col cols="12" lg="12">
      <v-card>
        <v-toolbar flat>
          <v-col cols="12" class="px-0">
            <div class="d-flex align-center">
              <div class="text-left">
                <v-toolbar-title class="page-title">
                  Online Payment Validator - Details
                </v-toolbar-title>
              </div>
              <div class="ml-auto">
                <v-btn @click.prevent="goBack" color="primary" class="ml-auto">
                  <v-icon dense>mdi-arrow-left</v-icon>
                  Back
                </v-btn>
              </div>
            </div>
          </v-col>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-divider></v-divider>

        <v-card-text class="px-0">
          <v-tabs grow v-model="currentTab">
            <v-tab href="#directLoad">Direct Load</v-tab>
            <v-tab href="#topup">Topup</v-tab>
          </v-tabs>

          <v-tabs-items v-model="currentTab">
            <v-tab-item value="directLoad">
              <direct-load :id="$route.params.id" :topup="false"></direct-load>
            </v-tab-item>
            <v-tab-item value="topup">
              <topup :id="$route.params.id" :topup="true"></topup>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
// import moment from "moment";
import ShareableMethods from "@/mixins/ShareableMethods";
import DirectLoad from './components/DirectLoad.vue'
import Topup from './components/Topup.vue'
// import _ from "lodash";

export default {
  mixins: [ShareableMethods],
  components: {DirectLoad, Topup},

  data() {
    return {
      currentTab: "directLoad",
      exportData: [],
      fileName: "",
      topup: false,

      search: "",
      table: {
        expanded: [],
        singleExpand: false,
        // sortBy: "dtCreated",
        sortDesc: true,
        loading: false,
        headers: [
          {
            text: "Filename",
            sortable: false,
            value: "name",
          },
          {
            text: "Proccessed Records",
            sortable: false,
            value: "processRecord",
          },
          {
            text: "Total Records",
            sortable: false,
            value: "total",
          },
          {
            text: "Status",
            align: "center",
            value: "status",
          },
          {
            text: "Date Uploaded",
            align: "status",
            value: "createdDate",
            formatter: (x) =>
              x ? this.formatDate(x, "MMM DD, YYYY h:mm:ss A") : null,
          },
          {
            text: "Actions",
            align: "center",
            value: "actions",
          },
        ],
        data: [],
      },
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    goBack() {
      this.$router.push({ name: "OnlinePaymentValidator" });
    },
    selectFile(file) {
      this.currentFile = file;
    },

    async getList(id) {
      this.table.loading = true;
      await this.$payment
        .get(`/verify-entry-transactions?transactionId=${id}&topup=${this.topup}`)
        .then((response) => {
          this.table.loading = false;
          const newArr = response.data.data;
          console.log(newArr);
          // console.log(newArr);
          this.table.data = newArr.verifyTransactions;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },
  },
  created() {
    console.log(this.$route);
  },

  watch: {
    // reload(val) {
    //   this.getDrawList(val);
    // },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>

<style scoped>
.p-0 {
  padding: 0px !important;
}

.sub-areas > div > table > thead > tr {
  background-color: red;
  border-radius: 10px;
}
</style>
